import Select from "react-select";
import React, { useEffect, useState } from "react";
import "./SearchSelect.css";
import { Form } from "react-bootstrap";

export default function SearchSelect(props) {
  const [focus, setFocus] = useState(false);
  let options = [];

  // Support direct options prop or build from data prop
  if (props.options) {
    options = props.options;
  } else {
    props?.data?.map((item, index) => {
      let option = {};
      if (props.valueField) {
        option.label = item[props.labelField];
        option.value = item[props.valueField];
        option.item = item;
      } else {
        option.value = item;
        option.label = item;
      }
      options.push(option);
    });
  }

  const validateInput = () => {
    setFocus(false);
    allValidations();
  };

  const validateMandatory = () => {
    if ((!props.value || props.value === "")) {
      if (!props.mandatoryFields?.includes(props.name)) {
        props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
      }
      return props.label + " is mandatory";
    } else {
      let mandatoryFieldsTemp = props.mandatoryFields;
      if (mandatoryFieldsTemp?.length > 0) {
        const index = mandatoryFieldsTemp?.indexOf(props.name);
        if (index > -1) {
          mandatoryFieldsTemp.splice(index, 1);
        }
        props.setMandatoryFields && props.setMandatoryFields(mandatoryFieldsTemp);
      }
      return "";
    }
  };

  const allValidations = () => {
    let errorMsg = "";
    if (props.required && !props.readOnly) {
      errorMsg = validateMandatory();
    }
    if (props.value && props.value !== "") {
      if (props.customValidation) {
        errorMsg = props.customValidation(props.value, props.name);
      }
    }
    if (props.setError) props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
  };

  useEffect(() => {
    if (props.required && !props.value && !props.mandatoryFields?.includes(props.name)) {
      props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
    }
  }, []);

  useEffect(() => {
    if (props.submit) {
      props.setFieldCount((prev) => ([...prev, props.name]));
      allValidations();
    }
  }, [props.submit]);

  return (
    <Form.Group className={`g-input-select`}>
      <Select
        {...props}
        classNamePrefix="select"
        className={`${props.loading ? "select-loading" : ""} ${props.error && props.error[props.name] ? "text-field-with-error" : ""}`}
        options={options}
        isLoading={props.loading}
        menuIsOpen={props.loading ? false : undefined}
        blurInputOnSelect={false}
        onBlur={(e) => { validateInput() }}
        value={props.value ? options.find(option => option.value === props.value) : {}}
        isDisabled={props.disabled}
        placeholder=""
        inputId={props.name}
        onFocus={() => { setFocus(true) }}
        onChange={(opt) => {
          let obj = { target: { name: props.name, value: opt.value, item: opt.item } };
          props.onChange(obj);
        }}
      />
      <Form.Label className={`${(focus || (props?.value && props?.value !== "")) ? "active" : ""} ${props.error && props.error[props.name] ? "text-label-with-error" : ""}`} htmlFor={props.name}>
        {props.label}
        {(props.required && !props.disabled) && <span style={{ color: '#810055' }}> *</span>}
        {(props.optional === true) && <span className="optional"> (optional)</span>}
      </Form.Label>
      {props.error && props.error[props.name] && (
        <Form.Text className="text-danger">
          {props.error[props.name]}
        </Form.Text>
      )}
    </Form.Group>
  );
}
